import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from 'src/app/core/user/user.service';
import {
  ToasterService,
  ToastStatus,
} from 'src/app/core/toaster/toaster.service';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.scss'],
})
export class ChangePasswordModalComponent implements OnInit {
  passwordForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private userService: UserService,
    private toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.passwordForm = this.fb.group({
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (this.passwordForm.valid) {
      this.userService
        .adminChangePassword(
          this.data.userId,
          this.passwordForm.get('newPassword')?.value
        )
        .subscribe(
          () => {
            this.toasterService.toast(
              ToastStatus.success,
              'Password changed successfully'
            );
            this.dialogRef.close(true);
          },
          error => {
            this.toasterService.toast(
              ToastStatus.error,
              error.error.message || 'Error changing password'
            );
          }
        );
    }
  }
}
